import {Subscription}                                                    from 'rxjs';
import {AfterContentInit, ChangeDetectionStrategy, Component, OnDestroy} from '@angular/core';
import {VersionInfoStore}                                                from '../../stores/common/versioninfo.store';

@Component({
  selector: 'ap-info-version',
  template: `
    <div class="ap-version">Agriport-Version: {{versionInfo}}</div>
  `,
  changeDetection: ChangeDetectionStrategy.Default
})
export class InfoVersionComponent implements OnDestroy, AfterContentInit {
  public loading$;
  public versionInfo;
  private _subscriptions: Array<Subscription> = [];

  constructor(private versionInfoStore: VersionInfoStore) {

  }

  ngAfterContentInit(): void {
    this.loading$ = this.versionInfoStore.Listen(s => s.loading);
    this.versionInfoStore.loadContactInformation();
    this.getDataFromStore();
  }

  getDataFromStore(): void {
    this._subscriptions.push(this.versionInfoStore.Listen(s => s.data).subscribe(async version => {
      if (!version) {
        return;
      }
      this.versionInfo = version;
    }));
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(d => {
      d.unsubscribe();
    });
  }
}
